/* MDL Set Offer · Musk de Lumière
   October 22, 2026: the house no longer gives the Discovery Set with two bottles. This file now only
   tidies bags from before that day: a Discovery Set line the house had added as the two bottle gift
   (property _mdl_offer: with_two) is taken out of the bag. A set the customer added themselves is never
   touched, nothing is ever added, and no offer line is shown. Runs on every page. */
(function () {
  'use strict';
  if (window.__MDL_SET_OFFER__) return;
  window.__MDL_SET_OFFER__ = true;

  var SET_VARIANT = 51715903979816;
  var SET_HANDLE = 'discovery-set-larbre-de-vie';
  var PROP = '_mdl_offer';
  var TAG = 'with_two';
  var FULL = /(^|[^0-9.])50 ?ml/i;
  var busy = false, again = false, tid = null;

  function isBottle(i) { return (i.product_type || '') === 'Eau de Parfum' && FULL.test(i.variant_title || ''); }
  function isSet(i) { return i.handle === SET_HANDLE || i.variant_id === SET_VARIANT; }
  function ours(i) { return isSet(i) && !!(i.properties && i.properties[PROP] === TAG); }
  function bottles(c) { var n = 0; (c.items || []).forEach(function (i) { if (isBottle(i)) n += i.quantity || 0; }); return n; }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
  }
  function hideLine() { var el = document.getElementById('mdlhCdOffer'); if (el) el.hidden = true; }

  function run() {
    if (busy) { again = true; return; }
    busy = true;
    hideLine();
    getCart().then(function (c) {
      var mine = (c.items || []).filter(ours);
      if (!mine.length) return;
      return post('/cart/change.js', { id: mine[0].key, quantity: 0 }).then(function () {
        if (document.querySelector('[data-lvcart]')) { window.location.reload(); return; }
        try { if (typeof window.mdlhCartRender === 'function') window.mdlhCartRender(); } catch (e) {}
        document.dispatchEvent(new CustomEvent('mdl:offer:settled'));
        again = true;
      });
    }).catch(function () {}).then(function () {
      busy = false;
      if (again) { again = false; soon(); }
    });
  }
  function soon() { clearTimeout(tid); tid = setTimeout(run, 140); }

  function init() {
    run();
    window.addEventListener('pageshow', soon);
    document.addEventListener('mdl:bag:open', soon);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.mdlSetOffer = { run: run, bottles: bottles };
})();
